module.exports = __webpack_public_path__ + "img/square.2aaad204.svg";